import { render, staticRenderFns } from "./lianXiRen.vue?vue&type=template&id=544fc2be&scoped=true"
import script from "./lianXiRen.vue?vue&type=script&lang=js"
export * from "./lianXiRen.vue?vue&type=script&lang=js"
import style0 from "./lianXiRen.vue?vue&type=style&index=0&id=544fc2be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544fc2be",
  null
  
)

export default component.exports